import {NgFor, NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ButtonComponent, MODAL_DATA, ModalRef} from '@sms-ir/ui-components';

import {SharedService} from '../../services/shared.service';
import {ShowDataModalInterface} from './models/show-data-modal.interface';

export interface ShowDataModalData {
  modalText?: string;
  modalHeader: string;
  data: ShowDataModalInterface;
  svg?: string;
}

@Component({
  selector: 'app-show-data-modal',
  standalone: true,
  imports: [NgIf, NgFor, ButtonComponent],
  templateUrl: './show-data-modal.component.html',
  styleUrls: ['./show-data-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowDataModalComponent {
  private readonly modalRef = inject<ModalRef<void>>(ModalRef);
  private readonly modalData = inject<ShowDataModalData>(MODAL_DATA);
  readonly sharedService = inject(SharedService);

  readonly modalText = this.modalData.modalText;
  readonly modalHeader = this.modalData.modalHeader;
  readonly data = this.modalData.data;
  readonly svg = this.modalData.svg;
  readonly objectKeys = Object.keys;

  dismiss(): void {
    this.modalRef.close();
  }
}
